import { render, staticRenderFns } from "./IssueCouponCardTable.vue?vue&type=template&id=5d5f5596&"
import script from "./IssueCouponCardTable.vue?vue&type=script&lang=js&"
export * from "./IssueCouponCardTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports